/**
 * @generated SignedSource<<082afdc2cf97e9f7ffd2a3ef7e614eae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryNewPaneTitle_item$data = {
  readonly skus: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ImageMultiSkuOverlay_sku">;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSummaryItemSkuDetails_item" | "ImageMultiSkuOverlay_item">;
  readonly " $fragmentType": "CheckoutMobileSummaryNewPaneTitle_item";
};
export type CheckoutMobileSummaryNewPaneTitle_item$key = {
  readonly " $data"?: CheckoutMobileSummaryNewPaneTitle_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryNewPaneTitle_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryNewPaneTitle_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ImageMultiSkuOverlay_sku"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ImageMultiSkuOverlay_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSummaryItemSkuDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "c83cb2072ae972b3d857fbf7ce5434ef";

export default node;
